module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "h1f"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface"
    }
  }, [_c('strong', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_c('strong', [_vm._v("Introduction")]), _vm._v(" Waking Up in Conversations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocline"
  }), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1"
    }
  }, [_vm._v("Part I"), _c('br'), _c('strong', [_vm._v("STORYTELLING CONVERSATIONS")]), _c('br'), _vm._v("Your Stories Are Not the Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v(" The Birth of Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v(" Emotions, Facts, and Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v(" Opinions and Private Conversations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v(" Processing Our Opinions")])]), _vm._v(" "), _c('p', {
    staticClass: "tocline"
  }), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II"), _c('br'), _c('strong', [_vm._v("COLLABORATIVE CONVERSATIONS")]), _c('br'), _vm._v("Seek to Understand and Absorb Other Perspectives")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v(" In Conversation with Others")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v(" Private Conversations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v(" Open Advocacy and Inquiry")]), _c('span', {
    attrs: {
      "aria-label": "page viii",
      "id": "page_viii",
      "role": "doc-pagebreak"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tocline"
  }), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III"), _c('br'), _c('strong', [_vm._v("CREATIVE CONVERSATIONS")]), _c('br'), _vm._v("Trust Your Intuition")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v(" From Resignation to Wonder")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v(" Intuition and Presence")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("10")]), _vm._v(" Co-creative Conversations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocline"
  }), _c('p', {
    staticClass: "tocpart"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV"), _c('br'), _c('strong', [_vm._v("COMMITMENT CONVERSATIONS")]), _c('br'), _vm._v("Don’t Make Promises You Can’t Keep")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("11")]), _vm._v(" The Conversational Bypass")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("12")]), _vm._v(" Requests, Offers, and Promises")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("13")]), _vm._v(" Recovery Conversations")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/concl",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Conclusion")]), _vm._v(" A Lifelong Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0